/* eslint-disable react/jsx-indent */
import styled from 'styled-components';
import { Button } from '../../fuse-buttons/src/buttons';

const StyledButton = styled(Button).attrs({
	className: 'fuse-pagination__chevron-button',
	'data-testid': 'fuse-pagination__chevron-button',
})`
	& {
		width: var(--spacing-global-space9);
		height: var(--spacing-global-space9);
		padding: 0;
		margin-right: var(--spacing-global-space3);
		border: none;
		font-size: 0;
	}

	&:active {
		box-shadow: none;
	}

	&:disabled {
		border: none;
	}

	&:hover:enabled {
		border: none;
		box-shadow: none;
	}

	&:before {
		background: var(--color-global-black);
		margin: 0;
	}

	&:hover:enabled:before,
	&:focus:enabled:before,
	&:active:enabled:before {
		background: var(--color-brand-mid);
	}

	&:focus-visible:enabled {
		outline: 2px solid var(--color-functional-focus);
		box-shadow: none;
	}

	&:focus:before {
		background: var(--color-brand-mid);
	}
`;

export default StyledButton;
